import axios from 'axios';
import { startLoading, endLoading, cleanStore } from 'src/old/actions';

const instance = axios.create();
export const superAxios = axios.create();

const logoutActions = (store, history) => {
  localStorage.clear();
  store.dispatch(cleanStore());
  history.push('/auth/login');
};

export const setupAxios = (store, history) => {
  instance.interceptors.request.use(
    config => {
      store.dispatch(startLoading());

      config.withCredentials = true;
      return config;
    },
    error => Promise.reject(error)
  );

  instance.interceptors.response.use(
    response => {
      store.dispatch(endLoading());
      return response;
    },
    error => {
      store.dispatch(endLoading());
      if (error.response?.status === 401 && !error.config.url.includes('/super/login')) {
        logoutActions(store, history);
      }
      return Promise.reject(error);
    }
  );

  superAxios.interceptors.request.use(
    config => {
      store.dispatch(startLoading());

      config.withCredentials = true;
      return config;
    },
    error => Promise.reject(error)
  );

  superAxios.interceptors.response.use(
    response => {
      store.dispatch(endLoading());
      return response;
    },
    error => {
      store.dispatch(endLoading());
      if (error.response?.status === 401) {
        logoutActions(store, history);
      }
      return Promise.reject(error);
    }
  );
};

export default instance;
